/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import { authActionCreators } from "../../service/action-creators";
import Loader from "../Loader";
import { FaLock, FaEye, FaEyeSlash, FaCheckCircle } from "react-icons/fa";

function ResetPassword() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { ResetPassword, ResetResponse } = bindActionCreators(authActionCreators, dispatch);
  const auth = useSelector((state) => state?.auth);
  const response = auth?.response;
  const isLoading = auth?.isLoading;
  const [formData, setFormData] = useState({});
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const query = new URLSearchParams(useLocation()?.search);

  const handleSubmit = (e) => {
    e.preventDefault();
    const Payload = {
      ...formData,
      token: query.get("token"),
    };
    if (formData?.newPassword && formData?.confirmPassword) {
      if (formData.newPassword !== formData.confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }
      ResetPassword(Payload);
    } else {
      toast.error("Please fill in both password fields");
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetResponse();
        history.replace("/");
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetResponse();
      }, 1500);
    }
  }, [response?.state]);

  const passwordStrength = () => {
    const p = formData?.newPassword || "";
    if (p.length === 0) return null;
    if (p.length < 6) return { label: "Weak", color: "#ef4444", width: "30%" };
    if (p.length < 10) return { label: "Fair", color: "#f97316", width: "60%" };
    return { label: "Strong", color: "#22c55e", width: "100%" };
  };

  const strength = passwordStrength();

  return (
    <div style={{
      minHeight: "100vh",
      background: "url(/images/dev/background.jpg) no-repeat center center/cover",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem",
    }}>
      <div style={{
        position: "fixed",
        inset: 0,
        background: "linear-gradient(135deg, rgba(0,0,0,0.55) 0%, rgba(0,100,60,0.45) 100%)",
      }} />

      {isLoading && <Loader />}

      <div style={{
        position: "relative",
        background: "#fff",
        borderRadius: "1.25rem",
        width: "100%",
        maxWidth: "440px",
        boxShadow: "0 24px 64px rgba(0,0,0,0.3)",
        overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{
          background: "var(--primaryColor)",
          padding: "2rem 2rem 1.5rem",
          color: "#fff",
          textAlign: "center",
        }}>
          <div style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 1rem",
            fontSize: "1.5rem",
          }}>
            <FaLock />
          </div>
          <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 700 }}>Reset Your Password</h2>
          <p style={{ margin: ".5rem 0 0", opacity: 0.85, fontSize: ".9rem" }}>
            Choose a strong, new password for your account
          </p>
        </div>

        {/* Body */}
        <div style={{ padding: "2rem" }}>
          <form onSubmit={handleSubmit}>
            {/* New Password */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{
                display: "block",
                fontSize: ".8rem",
                fontWeight: 600,
                color: "#555",
                marginBottom: ".4rem",
                textTransform: "uppercase",
                letterSpacing: ".05em",
              }}>
                New Password
              </label>
              <div style={{ position: "relative" }}>
                <input
                  id="newPassword"
                  name="newPassword"
                  type={showNew ? "text" : "password"}
                  required
                  placeholder="Enter new password"
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: ".75rem 2.75rem .75rem 1rem",
                    border: "1.5px solid #e0e0e0",
                    borderRadius: ".6rem",
                    fontSize: "1rem",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowNew(!showNew)}
                  style={{
                    position: "absolute",
                    right: ".75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#888",
                    fontSize: "1rem",
                    padding: 0,
                  }}
                >
                  {showNew ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {strength && (
                <div style={{ marginTop: ".5rem" }}>
                  <div style={{ height: "4px", background: "#e0e0e0", borderRadius: "4px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: strength.width, background: strength.color, borderRadius: "4px", transition: "width .3s" }} />
                  </div>
                  <span style={{ fontSize: ".75rem", color: strength.color, fontWeight: 600 }}>{strength.label}</span>
                </div>
              )}
            </div>

            {/* Confirm Password */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                fontSize: ".8rem",
                fontWeight: 600,
                color: "#555",
                marginBottom: ".4rem",
                textTransform: "uppercase",
                letterSpacing: ".05em",
              }}>
                Confirm Password
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showConfirm ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  required
                  placeholder="Re-enter new password"
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: ".75rem 2.75rem .75rem 1rem",
                    border: `1.5px solid ${
                      formData?.confirmPassword
                        ? formData.newPassword === formData.confirmPassword
                          ? "#22c55e"
                          : "#ef4444"
                        : "#e0e0e0"
                    }`,
                    borderRadius: ".6rem",
                    fontSize: "1rem",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirm(!showConfirm)}
                  style={{
                    position: "absolute",
                    right: ".75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#888",
                    fontSize: "1rem",
                    padding: 0,
                  }}
                >
                  {showConfirm ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {formData?.confirmPassword && formData.newPassword === formData.confirmPassword && (
                <div style={{ display: "flex", alignItems: "center", gap: ".3rem", marginTop: ".4rem", color: "#22c55e", fontSize: ".8rem" }}>
                  <FaCheckCircle /> Passwords match
                </div>
              )}
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                padding: ".9rem",
                background: "var(--primaryColor)",
                color: "#fff",
                border: "none",
                borderRadius: ".6rem",
                fontSize: "1rem",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Reset Password
            </button>

            <p style={{ textAlign: "center", marginTop: "1.25rem", marginBottom: 0 }}>
              <span
                style={{ color: "var(--primaryColor)", cursor: "pointer", fontWeight: 600, fontSize: ".9rem" }}
                onClick={() => history.push("/")}
              >
                ← Back to Login
              </span>
            </p>
          </form>
        </div>
      </div>

      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default ResetPassword;
